import { render, staticRenderFns } from "./ModalAssociateCase.vue?vue&type=template&id=5197b808&scoped=true&"
import script from "./ModalAssociateCase.vue?vue&type=script&lang=js&"
export * from "./ModalAssociateCase.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssociateCase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalAssociateCase.vue?vue&type=style&index=1&id=5197b808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197b808",
  null
  
)

export default component.exports